import React from 'react'
import Svg, { Path, Rect, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconLast = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconLast.dimensions.width} ${IconLast.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M1.999 22.59l11.427-8.543c.792-.493 1.314-1.436 1.314-2.451a2.948 2.948 0 00-1.381-2.497L1.999.602A1 1 0 00.803 2.204l11.426 8.543c.344.22.512.523.512.849 0 .326-.168.63-.444.803L.8 20.989A1 1 0 102 22.588z"
        fill={color || Color.premiumBlack}
        fillRule="nonzero"
      />
      <Rect width={2} height={23} rx={1} transform="translate(21)" fill={color || Color.premiumBlack} />
    </Svg>
  )
}

IconLast.dimensions = {
  width: 23,
  height: 23,
}

export default IconLast
